import { CBadge } from '@coreui/react';
import type { Schemas } from '../api/client';

/**
 * Barva podle KATEGORIE stavu, ne podle `colorHex` ze serveru — ten je dnes duha
 * (oranzova, zelena, modra…), ktera s brand manualem nejde dohromady. Stav rozlisi jeho
 * nazev; barva rika jen „rozpracovane / ve vyrobe / hotove / zrusene".
 * Cervena tu zamerne neni - ta patri signalum (po terminu, blokovano), ne bezne praci.
 */
const categoryStyles: Record<string, { background: string; color: string; border?: string }> = {
  Open: { background: 'var(--st-white)', color: 'var(--st-black)', border: '1px solid var(--st-grey-line)' },
  InProgress: { background: 'var(--st-indigo)', color: 'var(--st-white)' },
  Done: { background: 'var(--st-black)', color: 'var(--st-white)' },
  Cancelled: { background: 'var(--st-grey-soft)', color: 'var(--st-grey-text)' },
};

export function StateBadge({ state }: { state: Schemas['FlowStateResponse'] }) {
  const style = categoryStyles[state.category] ?? categoryStyles.Open;

  return <CBadge style={style} className="fw-semibold">{state.name}</CBadge>;
}

/**
 * Priorita. Urgentni je signal, proto cervena; vysoka jen zvyraznena; normalni a nizka
 * se neoznacuji vubec - neni duvod na ne upozornovat.
 */
export function PriorityBadge({ priority }: { priority: string }) {
  if (priority === 'Urgent') {
    return <CBadge color="danger">urgentní</CBadge>;
  }

  if (priority === 'High') {
    return <CBadge color="primary">vysoká</CBadge>;
  }

  return null;
}
